const MONEY_REGEX = /^\d+(\.\d{1,2})?$/;

const MONTH_REGEX = /^[0-9]*$/;

const POSITIVE_NUMBER_REGEX = /^(--|\d*\.?\d+)$/;

const SPECIAL_CHAR_REGEX = /[^\w\s]/;

const LINK_REGEX =
  /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9-._?=#]*)?/g;

export {
  MONEY_REGEX,
  MONTH_REGEX,
  SPECIAL_CHAR_REGEX,
  LINK_REGEX,
  POSITIVE_NUMBER_REGEX,
};
